import { Component, Inject, OnInit, ViewEncapsulation, Output, EventEmitter, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf } from '@angular/cdk/scrolling';
import { NoItemsComponent } from '../no-items/no-items.component';
import { MatButton } from '@angular/material/button';
import { ToastMessageComponent } from '../toast-message/toast-message.component';

export interface ConsignmentBatch {
  BatchNo: string;
  BatchName: string;
  CurrentQOH: number;
  selectedQty?: number;
  invalid?: boolean;
}

@Component({
    selector: 'app-consignment-popup',
    templateUrl: './consignment-popup.component.html',
    styleUrls: ['./consignment-popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf, NoItemsComponent, MatButton, ToastMessageComponent, TranslateModule]
})
export class ConsignmentPopupComponent implements OnInit {
  @Input() batchList: ConsignmentBatch[] = [];
  @Input() qtyRequired = 0;

  @Output() saved: EventEmitter<ConsignmentBatch[]> = new EventEmitter();
  @Output() cancelled: EventEmitter<void> = new EventEmitter();

  public dialogContent: any;
  public batches: ConsignmentBatch[] = [];
  toastShow: boolean = false;
  toastMessage: string = null;
  buttonText: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ConsignmentPopupComponent>,
              private translateService: TranslateService,) {
    this.dialogContent = data || {};
  }

  ngOnInit(): void {
    if (this.data) {
      if (this.data.batchList) { this.batchList = this.data.batchList; }
      if (this.data.qtyRequired !== undefined) { this.qtyRequired = this.data.qtyRequired; }
    }

    this.batches = this.batchList?.map(l => ({
      BatchNo: l.BatchNo || '',
      BatchName: l.BatchName ?? l.BatchName ?? '',
      CurrentQOH: Number(l.CurrentQOH ?? l.CurrentQOH ?? 0) || 0,
      selectedQty: Number(l.selectedQty) || 0,
      invalid: false
    }));
  }

  get totalSelected(): number {
    return this.batches.reduce((s, l) => s + (Number(l.selectedQty) || 0), 0);
  }

  get qtyRemaining(): number {
    return (this.qtyRequired || 0) - this.totalSelected;

  }

  close() {
    this.cancelled.emit();
    this.dialogRef.close();
  }

  clearAll() {
    this.batches.forEach(l => {
      l.selectedQty = 0,
      l.invalid = false
    });
  }

onQtyInput(event: Event, batch: ConsignmentBatch) {
  const input = event.target as HTMLInputElement;
  let selectedQty = parseInt(input.value, 10);
  if (isNaN(selectedQty) || selectedQty < 0) {
    selectedQty = 0;
    input.value = '0';
  }
  batch.selectedQty = selectedQty;
  if (selectedQty < 0 || selectedQty > batch.CurrentQOH) {
    batch.invalid = true;
  } else {
    batch.invalid = false;
  }
  const totalSelectedQty = this.totalSelected;
  if (totalSelectedQty > this.qtyRequired && selectedQty > 0) {
    batch.invalid = true;
  } else if (totalSelectedQty === this.qtyRequired) {
    this.batches.forEach(b => {
      const qty = b.selectedQty || 0;
    const exceedsBatch = qty > b.CurrentQOH;
    const negativeQty = qty < 0;

    if ((negativeQty) || (qty > 0 && exceedsBatch)) {
      b.invalid = true;
    } else {
      b.invalid = false;
    }
    });
  if (totalSelectedQty <= this.qtyRequired && selectedQty >= 1 && selectedQty <= batch.CurrentQOH) {
    batch.invalid = false;
  }
}
}

  save() {
    const hasInvalid = this.batches.some(l => (l as any).invalid === true);
    if (hasInvalid || this.totalSelected !== this.qtyRequired) {
      this.toastShow = true;
      this.toastMessage = hasInvalid ? this.translateService.instant('Consignment.toastrMsg') : this.translateService.instant('Consignment.invalidRemainingQty');
      return;
    }
    this.toastShow = false;
    const selected = this.batches.filter(l => Number(l.selectedQty) > 0).map(l => ({ ...l }));
    this.saved.emit(selected);
    this.dialogRef.close({  selectedData:selected, type: 'save' });
  }

  toastAutoDismiss(e: any) {
    try {
      this.toastShow = false;
      this.toastMessage = '';
    } catch (error) {
      console.error(error);
    }
  }
}
